export default __webpack_public_path__ + "static/media/Director's Certificate to Ms Annaliza H Lumanglas ( Batangas Branch ).8227b6f2.pdf";